import styled from "styled-components";
import { theme } from "@/styles/theme";
import { IFontProps } from "@/typings/Props";
import { media } from "@/styles/media";

export default function CompositionItem({ ...props }) {
  return (
    <ItemWrapper $bg={props.imgPath}>
      <P $fontColor={theme.colors.primary} $fontSize="1.7rem">
        {props.keyword_1}
      </P>
      <Img src="/learn/what-is-body-composition/arrows-up-down.png" alt="arrow" />
      <P $fontSize="1.7rem">{props.keyword_2}</P>
      <P id="desc" $fontColor={theme.colors.text.grayLight} $lineHeight="150%">
        {props.desc}
      </P>
    </ItemWrapper>
  );
}

const Img = styled.img`
  display: block;
  margin: auto;
  transition: filter 0.3s ease-out;
  filter: invert(100%) brightness(0%);
`;

const P = styled.p<IFontProps>`
  font-size: ${(props) => props.$fontSize};
  font-weight: ${(props) => props.$fontWeight};
  line-height: ${(props) => props.$lineHeight};
  color: ${(props) => props.$fontColor};
  margin-top: ${(props) => props.$marginTop};
  margin-right: ${(props) => props.$marginRight};
  text-align: center;
  white-space: pre-wrap;
  transition: 0.3s ease-out;

  &#desc {
    flex-grow: 1;
  }
`;

const ItemWrapper = styled.div<{ $bg: string }>`
  width: 462px;
  min-height: 512px;
  display: flex;
  padding: 70px 50px;
  gap: 20px;
  border-radius: 10px;
  flex-direction: column;
  background-color: ${theme.colors.background.white};
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    opacity: 0;
    z-index: 0;
    background: url(${({ $bg }) => $bg}) no-repeat center/cover;
    transition: opacity 0.3s ease-out;
  }
  &:hover::before {
    opacity: 1;
  }
  &:hover {
    ${Img}, ${P} {
      position: relative;
      z-index: 1;
    }

    ${Img} {
      filter: none;
    }
    ${P} {
      color: ${theme.colors.text.white};
      transition: 0.3s ease-out;
    }
  }
  ${media.tablet`
    width: 47%;
  `}
  ${media.phablet`
    width: 100%;
    min-height: 0px;
    height: auto;
  `}
`;
